// Handle needs navigation content toggle events

const $needsContentToggles = $('.needs-content-toggle');

if ($needsContentToggles.length > 0) {

  // When needs navigation toggle is clicked, set query string parameter "need" based on the selection
  $needsContentToggles.click(function(e) {
    const needId = $(this).attr('id');
    const urlParams = new URLSearchParams(window.location.search);

    // `pauseRandomization` set on Homepage; "Pause Needs Nav Randomization - Script [Universal viewer - Single Path]" webpart
    if (!pauseRandomization) {
      urlParams.set('need', needId);
    }

    const newUrl = new URL(window.location.href);
    newUrl.search = urlParams.toString();
    window.history.replaceState(null, '', newUrl.href);

    e.preventDefault(); // Don't change element focus nor scroll to needs content element
  })

  // When needs navigation tab is shown, then show the associated needs above content
  $needsContentToggles.on('show.bs.tab', function(e) {
    const $aboveContent = $($(e.target).data('href-above'));
    showNeedsContentAbove($aboveContent);
  });

  // When needs navigation tab is hidden, then hide the associated needs above content
  $needsContentToggles.on('hide.bs.tab', function(e) {
    const $aboveContent = $($(e.target).data('href-above'));
    hideNeedsContentAbove($aboveContent);
  });

  // On document ready, activate the needs navigation specified by the query string parameter "need". Otherwise show a random need (as functional spec indicates...)
  $(function() {
    const urlParams = new URLSearchParams(window.location.search);
    const needQueryString = urlParams.get('need');
    let $selectedNeed;

    // `pauseRandomization` set on Homepage; "Pause Needs Nav Randomization - Script [Universal viewer - Single Path]" webpart
    if (pauseRandomization) {
      $selectedNeed = $('#needs-navigation a:first');
    } else {
      $selectedNeed = $needsContentToggles.filter('[id="' + needQueryString + '"]');

      if ($selectedNeed.length === 0) {
        const randomNeedIndex = Math.floor(Math.random() * $needsContentToggles.length);
        $selectedNeed = $needsContentToggles[randomNeedIndex];
      }
    }

    $selectedNeed.click();
  });
}


// Shows the needs content above
function showNeedsContentAbove($aboveContent) {
  const $homepageMainImage = $aboveContent.find('.homepage-main-image');
  const $abovePromoUnitWrapper = $aboveContent.closest('.promo-unit-wrapper');
  const theme = $homepageMainImage.data('theme');
  const backgroundImage = $homepageMainImage.data('background-image');

  $aboveContent.addClass('show active');
  $abovePromoUnitWrapper.removeClass('promo-unit-wrapper-light promo-unit-wrapper-dark');
  $abovePromoUnitWrapper.addClass(theme);
  $abovePromoUnitWrapper.css('background-image', backgroundImage);
}

// Hides the needs content above
function hideNeedsContentAbove($aboveContent) {
  $aboveContent.removeClass('show active');
}
